import React from 'react';
import styles from '../main.module.css';

const ConversionResultModal = ({ 
    isVisible, 
    onClose, 
    title,
    icon,
    convertedText, 
    onInsertText, 
    onCopyText 
}) => {
    if (!isVisible) return null;

    return (
        <div className={styles.modalBackdrop} onClick={onClose}>
            <div className={styles.modalContentWrapper} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h3><i className={`${icon} mr-2`}></i>{title}</h3>
                    <button onClick={onClose} className={styles.modalCloseBtn}>×</button>
                </div>
                
                <div className={styles.modalBody}>
                    <div className={styles.convertedTextContainer}>
                        <h4>Result:</h4>
                        <div className={styles.convertedTextBox}>
                            {convertedText}
                        </div>
                    </div>
                </div>
                
                <div className={styles.modalFooter}>
                    <button 
                        onClick={onClose} 
                        className={`${styles.actionButton} ${styles.actionButtonSecondary}`}
                    >
                        Close
                    </button>
                    <button 
                        onClick={onCopyText} 
                        className={`${styles.actionButton} ${styles.actionButtonSecondary}`}
                    >
                        <i className="fas fa-copy mr-1"></i>Copy Text
                    </button>
                    <button 
                        onClick={onInsertText} 
                        className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
                    >
                        <i className="fas fa-plus mr-1"></i>Insert into Editor
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConversionResultModal;
